'use strict';

angular.module('ClinicApp').factory('FeatureService', function($http, ClinicConfig) {
  return {
    list: function(specialtyId) {
      return $http.get(ClinicConfig.HOSTNAME + '/feature', {
        params: {
          specialty: specialtyId,
        },
      }).then(function(response) {
        return response.data;
      });
    },
  };
});
